import styleInject from '../../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z=".replacement-confirmation-container{padding:48px 48px 48px 32px!important}@media only screen and (max-width:767px){.replacement-confirmation-container{padding:32px 16px!important}}.replacement-confirmation-thank-you-column{align-items:center;justify-content:center}.replacement-confirmation-box{width:100%}.replacement-confirmation-box div{max-width:664px}";styleInject(css_248z);

export { css_248z as default };
//# sourceMappingURL=styles.scss.js.map
